import { render, staticRenderFns } from "./EnrollmentWidget.vue?vue&type=template&id=455b0c28&scoped=true&"
import script from "./EnrollmentWidget.vue?vue&type=script&lang=js&"
export * from "./EnrollmentWidget.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentWidget.vue?vue&type=style&index=0&id=455b0c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b0c28",
  null
  
)

export default component.exports